var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('VideoComponentNoodplan'),_c('nood-aseg'),_c('nood-bseg'),_c('nood-cseg'),_c('white-label'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }